import * as React from 'react';

import * as styles from './index.css';
import { EyeOpened, EyeClosed } from './icons';
import { mergeStyles } from '@cian/utils';
import { Preloader } from '@cian/components';
import { IGetProductsParams } from '../../tracking/hide_offer';

export interface IHideButtonStoreProps {
  isChecked?: boolean;
  isFetching?: boolean;
  productParams?: IGetProductsParams;
}

export interface IHideButtonDispatchProps {
  hideOffer?(): void;
  restoreOffer?(): void;
}
export interface IHideButtonOwnProps {
  isDisabled?: boolean;
  className?: string;
}

export type IHideButtonProps = IHideButtonStoreProps & IHideButtonDispatchProps & IHideButtonOwnProps;

export class HideButton extends React.Component<IHideButtonProps, {}> {
  public render() {
    const { isChecked, isDisabled, hideOffer, restoreOffer, className, isFetching } = this.props;

    return (
      <div {...mergeStyles(styles['hide_button_outer'], className)}>
        {isFetching ? (
          <div className={styles['preloader']}>
            <Preloader size={16} />
          </div>
        ) : isChecked ? (
          <EyeOpened />
        ) : (
          <EyeClosed />
        )}
        <input
          className={styles['hide_button_checkbox']}
          type="checkbox"
          checked={isChecked}
          onChange={isChecked ? restoreOffer : hideOffer}
          disabled={isDisabled}
          title={isChecked ? 'Показать объявление' : ' Скрыть объявление'}
        />
      </div>
    );
  }
}
